const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class Prosperity extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.Prosperity,
            "Each civilization gains 1 food for each of its happy faces (max 8).",
            {}
        )
    }
}

module.exports = Prosperity;